import { mixins } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { FormProps } from './Form.types';

export const StyledForm = styled.form<StyledMods<Pick<FormProps, 'height'>>>`
    ${mixins.whByModValue('height')};
`;
